import { ChangeDetectionStrategy, Component, inject, model, computed, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { DecimalPipe } from '@angular/common';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { ProjelerService } from './projeler.service';
import { FikoYTRequestService } from '@/src/app/shared/services/fikoyt-request.service';
import { DosyaKutusuComponent } from '@/src/service/fikoyt-ui/src/lib/parametreler/dosya-kutusu/dosya-kutusu.component';
import { HmiLookupService } from '@/src/app/uygulamalar/hmi-pano/pano/pages/personel/services/hmi-lookup.service';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';

@Component({
  selector: 'projeler-edit',
  standalone: true,
  imports: [FormsModule, NzFormModule, NzInputModule, NzSelectModule, NzDatePickerModule, NzModalModule, NzSpinModule, DecimalPipe, DosyaKutusuComponent,
    CdkTextareaAutosize],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="pe">
      <div class="pe__baslik">
        <div class="pe__baslik-ikon">
          <span class="pe__baslik-ikon-inner"></span>
        </div>
        <span class="pe__baslik-metin">Proje Bilgileri</span>
        <div class="pe__baslik-cizgi"></div>
      </div>

      <div class="pe__alan pe__alan--giris" [class.pe__alan--dolu]="p().projeAdi">
        <label class="pe__etiket">
          <span class="pe__etiket-nokta pe__etiket-nokta--zorunlu"></span>
          Proje Adi
        </label>
        <div class="pe__input-wrap">
          <input nz-input autocomplete="off" readonly onfocus="this.removeAttribute('readonly')"
                 class="pe__input"
                 placeholder="Proje adini girin..."
                 [ngModel]="p().projeAdi || ''"
                 (ngModelChange)="guncelle('projeAdi', $event)"
                 (focus)="odakAlan = 'projeAdi'"
                 (blur)="odakAlan = ''" />
          <div class="pe__input-cizgi" [class.pe__input-cizgi--aktif]="odakAlan === 'projeAdi'"></div>
        </div>
      </div>

      <div class="pe__alan" [class.pe__alan--dolu]="p().aciklama">
        <label class="pe__etiket">Aciklama</label>
        <div class="pe__input-wrap">
          <textarea nz-input autocomplete="off" readonly onfocus="this.removeAttribute('readonly')"
                    class="pe__input pe__input--textarea"
                    cdkTextareaAutosize [cdkAutosizeMinRows]="2" [cdkAutosizeMaxRows]="5"
                    placeholder="Proje aciklamasi..."
                    [ngModel]="p().aciklama || ''"
                    (ngModelChange)="guncelle('aciklama', $event)"
                    (focus)="odakAlan = 'aciklama'"
                    (blur)="odakAlan = ''"></textarea>
          <div class="pe__input-cizgi" [class.pe__input-cizgi--aktif]="odakAlan === 'aciklama'"></div>
        </div>
      </div>

      <div class="pe__satir">
        <div class="pe__alan pe__alan--flex">
          <label class="pe__etiket">
            <span class="pe__etiket-ikon">&#9716;</span>
            Baslangic
          </label>
          <div class="pe__input-wrap">
            <nz-date-picker class="pe__tarih"
                            nzPlaceHolder="Tarih seçin..."
                            [ngModel]="baslangicDate()"
                            (ngModelChange)="tarihGuncelle('baslangicTarihi', $event)"
                            (nzOnOpenChange)="odakAlan = $event ? 'baslangic' : ''"
                            nzFormat="dd.MM.yyyy">
            </nz-date-picker>
            <div class="pe__input-cizgi" [class.pe__input-cizgi--aktif]="odakAlan === 'baslangic'"></div>
          </div>
        </div>
        <div class="pe__satir-ok">&#8594;</div>
        <div class="pe__alan pe__alan--flex">
          <label class="pe__etiket">
            <span class="pe__etiket-ikon">&#9717;</span>
            Bitis
          </label>
          <div class="pe__input-wrap">
            <nz-date-picker class="pe__tarih"
                            nzPlaceHolder="Tarih seçin..."
                            [ngModel]="bitisDate()"
                            (ngModelChange)="tarihGuncelle('bitisTarihi', $event)"
                            (nzOnOpenChange)="odakAlan = $event ? 'bitis' : ''"
                            nzFormat="dd.MM.yyyy">
            </nz-date-picker>
            <div class="pe__input-cizgi" [class.pe__input-cizgi--aktif]="odakAlan === 'bitis'"></div>
          </div>
        </div>
      </div>

      <div class="pe__satir">
        <div class="pe__alan pe__alan--flex">
          <label class="pe__etiket">Oncelik</label>
          <div class="pe__input-wrap">
            <nz-select class="pe__secim"
                       nzPlaceHolder="Secin"
                       [ngModel]="p().oncelik || 'normal'"
                       (ngModelChange)="guncelle('oncelik', $event)"
                       (nzOpenChange)="odakAlan = $event ? 'oncelik' : ''"
                       [nzCustomTemplate]="peOncelikTpl">
              <nz-option nzValue="dusuk" nzLabel="Dusuk" nzCustomContent>
                <div class="sel-item"><span class="sel-dot" style="background:#52c41a"></span><span class="sel-ad">Dusuk</span></div>
              </nz-option>
              <nz-option nzValue="normal" nzLabel="Normal" nzCustomContent>
                <div class="sel-item"><span class="sel-dot" style="background:#1890ff"></span><span class="sel-ad">Normal</span></div>
              </nz-option>
              <nz-option nzValue="yuksek" nzLabel="Yuksek" nzCustomContent>
                <div class="sel-item"><span class="sel-dot" style="background:#faad14"></span><span class="sel-ad">Yuksek</span></div>
              </nz-option>
              <nz-option nzValue="acil" nzLabel="Kritik" nzCustomContent>
                <div class="sel-item"><span class="sel-dot" style="background:#ff4d4f"></span><span class="sel-ad">Kritik</span></div>
              </nz-option>
            </nz-select>
            <ng-template #peOncelikTpl let-selected>
              <span class="sel-item"><span class="sel-dot" [style.background]="peOncelikRenk(selected?.nzValue)"></span><span class="sel-ad">{{ selected?.nzLabel }}</span></span>
            </ng-template>
            <div class="pe__input-cizgi" [class.pe__input-cizgi--aktif]="odakAlan === 'oncelik'"
                 [style.background]="oncelikGradient()"></div>
          </div>
        </div>
        <div class="pe__alan pe__alan--flex">
          <label class="pe__etiket">Durum</label>
          <div class="pe__input-wrap">
            <nz-select class="pe__secim"
                       nzPlaceHolder="Secin"
                       [ngModel]="p().durum || 'planlama'"
                       (ngModelChange)="guncelle('durum', $event)"
                       (nzOpenChange)="odakAlan = $event ? 'durum' : ''"
                       [nzCustomTemplate]="peDurumTpl">
              <nz-option nzValue="planlama" nzLabel="Planlama" nzCustomContent>
                <div class="sel-item"><span class="sel-dot" style="background:#1890ff"></span><span class="sel-ad">Planlama</span></div>
              </nz-option>
              <nz-option nzValue="devam-ediyor" nzLabel="Devam Ediyor" nzCustomContent>
                <div class="sel-item"><span class="sel-dot" style="background:#52c41a"></span><span class="sel-ad">Devam Ediyor</span></div>
              </nz-option>
              <nz-option nzValue="tamamlandi" nzLabel="Tamamlandi" nzCustomContent>
                <div class="sel-item"><span class="sel-dot" style="background:#8c8c8c"></span><span class="sel-ad">Tamamlandi</span></div>
              </nz-option>
              <nz-option nzValue="iptal" nzLabel="Iptal" nzCustomContent>
                <div class="sel-item"><span class="sel-dot" style="background:#ff4d4f"></span><span class="sel-ad">Iptal</span></div>
              </nz-option>
            </nz-select>
            <ng-template #peDurumTpl let-selected>
              <span class="sel-item"><span class="sel-dot" [style.background]="peDurumRenk(selected?.nzValue)"></span><span class="sel-ad">{{ selected?.nzLabel }}</span></span>
            </ng-template>
            <div class="pe__input-cizgi" [class.pe__input-cizgi--aktif]="odakAlan === 'durum'"></div>
          </div>
        </div>
      </div>

      <div class="pe__alan">
        <label class="pe__etiket">
          <span class="pe__etiket-ikon">&#128101;</span>
          Musteri
        </label>
        <div class="pe__input-wrap">
          <nz-select class="pe__secim"
                     nzPlaceHolder="Musteri secin..."
                     nzShowSearch nzAllowClear nzServerSearch
                     [ngModel]="p().musteri || null"
                     (ngModelChange)="guncelle('musteri', $event)"
                     (nzOnSearch)="lookup.musterileriYukle($event)"
                     (nzOpenChange)="$event && lookup.musterileriYukle()"
                     (focus)="odakAlan = 'musteri'"
                     (blur)="odakAlan = ''"
                     [nzCustomTemplate]="peMusteriTpl">
            @for (m of lookup.musteriler(); track m._id) {
              <nz-option [nzValue]="m.firmaAdi" [nzLabel]="m.firmaAdi" nzCustomContent>
                <div class="sel-item"><span class="sel-emoji">🏪</span><div class="sel-bilgi"><span class="sel-ad">{{ m.firmaAdi }}</span>@if (m.yetkili) { <span class="sel-detay">{{ m.yetkili }}</span> }</div></div>
              </nz-option>
            }
          </nz-select>
          <ng-template #peMusteriTpl let-selected>
            <span class="sel-item"><span class="sel-emoji">🏪</span><span class="sel-ad">{{ selected.nzLabel }}</span></span>
          </ng-template>
          <div class="pe__input-cizgi" [class.pe__input-cizgi--aktif]="odakAlan === 'musteri'"></div>
        </div>
      </div>

      <div class="pe__alan">
        <label class="pe__etiket">
          <span class="pe__etiket-ikon">&#128193;</span>
          Dosyalar
        </label>
        <dosya-kutusu [deger]="dosyaKutusuDeger()" (degerChange)="guncelle('dosyaKutusu', $event)" [sadeceOkunur]="false" />
      </div>

      <div class="pe__satir">
        <div class="pe__alan pe__alan--flex">
          <label class="pe__etiket">
            <span class="pe__etiket-ikon">&#128236;</span>
            Mail Hesabi
          </label>
          <div class="pe__input-wrap">
            <nz-select class="pe__secim"
                       nzPlaceHolder="Hesap secin..."
                       nzShowSearch
                       nzAllowClear
                       [ngModel]="p().mailHesap || null"
                       (ngModelChange)="mailHesapDegisti($event)"
                       (nzOpenChange)="odakAlan = $event ? 'mailHesap' : ''; $event && mailHesaplariYukle()"
                       [nzCustomTemplate]="peMailTpl">
              @for (h of mailHesaplari(); track h._id) {
                <nz-option [nzValue]="h._id" [nzLabel]="h.email" nzCustomContent>
                  <div class="sel-item"><span class="sel-emoji">📬</span><span class="sel-ad">{{ h.email }}</span></div>
                </nz-option>
              }
            </nz-select>
            <ng-template #peMailTpl let-selected>
              <span class="sel-item"><span class="sel-emoji">📬</span><span class="sel-ad">{{ selected.nzLabel }}</span></span>
            </ng-template>
            <div class="pe__input-cizgi" [class.pe__input-cizgi--aktif]="odakAlan === 'mailHesap'"></div>
          </div>
        </div>
        <div class="pe__alan pe__alan--flex">
          <label class="pe__etiket">
            <span class="pe__etiket-ikon">&#128231;</span>
            Ilgili Mail
          </label>
          <div class="pe__input-wrap" style="display:flex;gap:6px;align-items:center">
            <nz-select class="pe__secim" style="flex:1"
                       nzPlaceHolder="{{ p().mailHesap ? 'Mail secin...' : 'Once hesap secin' }}"
                       nzShowSearch
                       nzAllowClear
                       nzServerSearch
                       [nzDisabled]="!p().mailHesap"
                       [ngModel]="p().mailRef || null"
                       (ngModelChange)="guncelle('mailRef', $event)"
                       (nzOnSearch)="mailAra($event)"
                       (nzOpenChange)="odakAlan = $event ? 'mailRef' : ''; $event && mailAra('')"
                       [nzCustomTemplate]="peMailRefTpl">
              @for (m of mailler(); track m._id) {
                <nz-option [nzValue]="m._id" [nzLabel]="m.konu || m.kimden || m._id" nzCustomContent>
                  <div style="display:flex;align-items:center;gap:6px">
                    <span>{{ m.yanitMi ? '↩️' : m.ekSayi > 0 ? '📎' : '📧' }}</span>
                    <div style="flex:1;min-width:0">
                      <div style="font-size:13px;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">{{ m.konu || '(Konusuz)' }}</div>
                      <div style="font-size:11px;opacity:.6;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">{{ m.kimden }} · {{ m.tarihStr }}</div>
                    </div>
                    <button class="pe__onizle-btn" (click)="mailOnizle(m._id); $event.stopPropagation()" title="Önizle">👁</button>
                  </div>
                </nz-option>
              }
            </nz-select>
            <ng-template #peMailRefTpl let-selected>
              <span class="sel-item"><span class="sel-emoji">📧</span><span class="sel-ad">{{ selected.nzLabel }}</span></span>
            </ng-template>
            @if (p().mailRef) {
              <button class="pe__mail-onizle-ikon" (click)="mailOnizle(p().mailRef)" title="Maili önizle">👁</button>
            }
          </div>
        </div>
      </div>
    </div>

    <nz-modal [(nzVisible)]="mailModalAcik" [nzTitle]="mailDetay()?.konu || 'Mail Önizleme'"
              nzWidth="600px" [nzFooter]="null" (nzOnCancel)="mailModalAcik = false">
      <ng-container *nzModalContent>
        @if (mailDetay(); as md) {
          <div class="pe__mail-detay">
            <div class="pe__mail-meta">
              <div><strong>Kimden:</strong> {{ md.kimden }}</div>
              <div><strong>Kime:</strong> {{ md.kime }}</div>
              <div><strong>Tarih:</strong> {{ md.tarih }}</div>
            </div>
            @if (md.ekler && md.ekler.length > 0) {
              <div class="pe__mail-ekler">
                @for (ek of md.ekler; track ek.ismi) {
                  <div class="pe__ek-chip" (click)="ekIndir(ek)">
                    <span>📥</span>
                    <span>{{ ek.ismi || 'dosya' }}</span>
                    @if (ek.boyut) { <span class="pe__ek-boyut">{{ (ek.boyut / 1024) | number:'1.0-0' }} KB</span> }
                  </div>
                }
              </div>
            }
            <div class="pe__mail-icerik" [innerHTML]="md.html || md.metin || '(İçerik yok)'"></div>
          </div>
        } @else {
          <nz-spin nzSimple style="display:flex;justify-content:center;padding:40px"></nz-spin>
        }
      </ng-container>
    </nz-modal>
  `,
  styles: [`

    :host { display: block; }

    .pe {
      display: flex;
      flex-direction: column;
      gap: 14px;
      padding: 6px 0;
      animation: peSlideIn .4s cubic-bezier(.16,1,.3,1) both;
    }

    @keyframes peSlideIn {
      from { opacity: 0; transform: translateY(12px); }
      to   { opacity: 1; transform: translateY(0); }
    }

    .pe__baslik {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 2px;
    }

    .pe__baslik-ikon {
      width: 28px;
      height: 28px;
      border-radius: 8px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      overflow: hidden;
    }

    .pe__baslik-ikon::after {
      content: '';
      position: absolute;
      inset: 0;
      background: linear-gradient(135deg, rgba(255,255,255,.25) 0%, transparent 60%);
      border-radius: inherit;
    }

    .pe__baslik-ikon-inner {
      width: 12px;
      height: 12px;
      border: 2px solid rgba(255,255,255,.9);
      border-radius: 3px;
      position: relative;
    }

    .pe__baslik-ikon-inner::after {
      content: '';
      position: absolute;
      top: 2px;
      left: 2px;
      width: 4px;
      height: 4px;
      background: rgba(255,255,255,.9);
      border-radius: 1px;
    }

    .pe__baslik-metin {
      font-size: 13px;
      font-weight: 600;
      letter-spacing: .3px;
      color: var(--py-metin, #333);
      text-transform: uppercase;
    }

    .pe__baslik-cizgi {
      flex: 1;
      height: 1px;
      background: linear-gradient(90deg, var(--py-kenarlik, rgba(0,0,0,.08)), transparent);
    }

    .pe__alan {
      display: flex;
      flex-direction: column;
      gap: 6px;
      animation: peAlanIn .35s cubic-bezier(.16,1,.3,1) both;
      animation-delay: calc(var(--pe-i, 0) * 60ms);
    }

    .pe__alan:nth-child(2) { --pe-i: 1; }
    .pe__alan:nth-child(3) { --pe-i: 2; }

    @keyframes peAlanIn {
      from { opacity: 0; transform: translateX(-8px); }
      to   { opacity: 1; transform: translateX(0); }
    }

    .pe__alan--flex { flex: 1; min-width: 0; }

    .pe__etiket {
      display: flex;
      align-items: center;
      gap: 5px;
      font-size: 11.5px;
      font-weight: 500;
      color: var(--py-metin, #555);
      opacity: .7;
      letter-spacing: .2px;
      transition: opacity .2s;
    }

    .pe__alan:hover .pe__etiket,
    .pe__alan--dolu .pe__etiket {
      opacity: 1;
    }

    .pe__etiket-nokta {
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background: var(--py-kenarlik, #d9d9d9);
      transition: background .2s;
    }

    .pe__etiket-nokta--zorunlu {
      background: #667eea;
      box-shadow: 0 0 6px rgba(102,126,234,.4);
    }

    .pe__etiket-ikon {
      font-size: 12px;
      opacity: .6;
    }

    .pe__input-wrap {
      position: relative;
    }

    .pe__input {
      border-radius: 8px !important;
      border-color: var(--py-kenarlik, rgba(0,0,0,.1)) !important;
      background: var(--py-arkaplan-hover, rgba(0,0,0,.02)) !important;
      transition: border-color .25s, box-shadow .25s, background .25s !important;
      font-size: 13px !important;
    }

    .pe__input:hover {
      border-color: rgba(102,126,234,.3) !important;
      background: var(--py-arkaplan-hover, rgba(0,0,0,.01)) !important;
    }

    .pe__input:focus {
      border-color: rgba(102,126,234,.5) !important;
      box-shadow: 0 0 0 2px rgba(102,126,234,.08) !important;
      background: transparent !important;
    }

    .pe__input--textarea {
      resize: none !important;
    }

    .pe__input-cizgi {
      position: absolute;
      bottom: 0;
      left: 50%;
      width: 0;
      height: 2px;
      border-radius: 2px;
      background: linear-gradient(90deg, #667eea, #764ba2);
      transition: width .35s cubic-bezier(.16,1,.3,1), left .35s cubic-bezier(.16,1,.3,1);
      pointer-events: none;
    }

    .pe__input-cizgi--aktif {
      width: 100%;
      left: 0;
    }

    .pe__satir {
      display: flex;
      gap: 12px;
      align-items: flex-end;
    }

    .pe__satir-ok {
      font-size: 14px;
      color: var(--py-metin, #999);
      opacity: .35;
      padding-bottom: 10px;
      flex-shrink: 0;
      transition: opacity .2s;
    }

    .pe__satir:hover .pe__satir-ok {
      opacity: .6;
    }

    .pe__tarih {
      width: 100%;
    }

    :host ::ng-deep .pe__tarih .ant-picker {
      background: var(--py-arkaplan-hover, rgba(0,0,0,.02)) !important;
      border: 1px solid var(--py-kenarlik, rgba(0,0,0,.1)) !important;
      border-radius: 8px !important;
      min-height: 34px;
      width: 100% !important;
      font-size: 13px !important;
      transition: border-color .25s, box-shadow .25s, background .25s !important;
    }
    :host ::ng-deep .pe__tarih .ant-picker input { font-size: 13px !important; color: var(--py-metin) !important; }

    :host ::ng-deep .pe__tarih:hover .ant-picker {
      border-color: rgba(102,126,234,.3) !important;
      background: var(--py-arkaplan-hover, rgba(0,0,0,.01)) !important;
    }

    :host ::ng-deep .pe__tarih .ant-picker-focused {
      border-color: rgba(102,126,234,.5) !important;
      background: transparent !important;
      box-shadow: 0 0 0 2px rgba(102,126,234,.08) !important;
    }

    .pe__secim {
      width: 100%;
    }

    :host ::ng-deep .pe__secim .ant-select-selector {
      border-radius: 8px !important;
      border-color: var(--py-kenarlik, rgba(0,0,0,.1)) !important;
      background: var(--py-arkaplan-hover, rgba(0,0,0,.02)) !important;
      transition: border-color .25s, box-shadow .25s !important;
    }

    :host ::ng-deep .pe__secim:hover .ant-select-selector {
      border-color: rgba(102,126,234,.3) !important;
    }

    :host ::ng-deep .pe__secim.ant-select-focused .ant-select-selector {
      border-color: rgba(102,126,234,.5) !important;
      box-shadow: 0 0 0 2px rgba(102,126,234,.08) !important;
    }

    .pe__oncelik-dot,
    .pe__durum-dot {
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      margin-right: 6px;
      vertical-align: middle;
      box-shadow: 0 0 4px currentColor;
    }

    @media (max-width: 480px) {
      .pe__satir {
        flex-direction: column;
        gap: 14px;
      }
      .pe__satir-ok { display: none; }
    }

    .pe__onizle-btn {
      background: none; border: none; cursor: pointer; font-size: 14px;
      opacity: .4; transition: opacity .2s; padding: 2px 4px; flex-shrink: 0;
    }
    .pe__onizle-btn:hover { opacity: 1; }

    .pe__mail-onizle-ikon {
      width: 32px; height: 32px; border-radius: 6px; flex-shrink: 0;
      display: flex; align-items: center; justify-content: center;
      background: rgba(102,126,234,.1); border: none; cursor: pointer;
      font-size: 14px; transition: all .2s;
    }
    .pe__mail-onizle-ikon:hover { background: rgba(102,126,234,.25); transform: scale(1.1); }

    .pe__mail-detay { display: flex; flex-direction: column; gap: 12px; }
    .pe__mail-ekler { display: flex; flex-wrap: wrap; gap: 6px; }
    .pe__ek-chip {
      display: inline-flex; align-items: center; gap: 5px;
      padding: 4px 10px; border-radius: 6px; cursor: pointer;
      background: var(--py-arkaplan-hover, #f0f0f0);
      border: 1px solid var(--py-kenarlik, #e8e8e8);
      font-size: 12px; transition: all .2s;
    }
    .pe__ek-chip:hover { background: rgba(102,126,234,.1); border-color: rgba(102,126,234,.3); }
    .pe__ek-boyut { opacity: .5; font-size: 11px; }
    .pe__mail-meta {
      display: flex; flex-direction: column; gap: 4px;
      padding: 10px; border-radius: 8px;
      background: var(--py-arkaplan-hover, #f5f5f5);
      font-size: 13px; color: var(--py-metin);
    }
    .pe__mail-icerik {
      padding: 12px; border-radius: 8px;
      background: var(--py-arkaplan, #fff);
      border: 1px solid var(--py-kenarlik, #e8e8e8);
      font-size: 13px; line-height: 1.6;
      max-height: 400px; overflow-y: auto;
      word-break: break-word;
    }
  `],
})
export class ProjelerEditComponent extends FikoYTKokBilesenComponent {
  parametreler = model<any>();
  private projelerServis = inject(ProjelerService);
  lookup = inject(HmiLookupService);
  odakAlan = '';

  constructor() { super(); }

  p = computed(() => this.parametreler()?.ek || {});

  dosyaKutusuDeger = computed(() => this.p()?.dosyaKutusu || { dosyalar: [] });

  dosyaKutusuDegerSet(yeni: any) {
    this.guncelle('dosyaKutusu', yeni);
  }

  peOncelikRenk(v: string): string {
    const m: Record<string, string> = { 'dusuk': '#52c41a', 'normal': '#1890ff', 'yuksek': '#faad14', 'acil': '#ff4d4f' };
    return m[v] || '#1890ff';
  }

  peDurumRenk(v: string): string {
    const m: Record<string, string> = { 'planlama': '#1890ff', 'devam-ediyor': '#52c41a', 'tamamlandi': '#8c8c8c', 'iptal': '#ff4d4f' };
    return m[v] || '#1890ff';
  }

  oncelikGradient = computed(() => {
    const map: Record<string, string> = {
      dusuk: 'linear-gradient(90deg, #52c41a, #95de64)',
      normal: 'linear-gradient(90deg, #1890ff, #69c0ff)',
      yuksek: 'linear-gradient(90deg, #faad14, #ffc53d)',
      acil: 'linear-gradient(90deg, #ff4d4f, #ff7875)',
    };
    return map[this.p().oncelik] || map['normal'];
  });

  guncelle(alan: string, deger: any) {
    const params = this.parametreler();
    if (params?.ek) {
      params.ek[alan] = deger;
      this.parametreler.set({ ...params });
    }
  }

  baslangicDate = computed(() => {
    const v = this.p()?.baslangicTarihi;
    return v ? new Date(v) : null;
  });
  bitisDate = computed(() => {
    const v = this.p()?.bitisTarihi;
    return v ? new Date(v) : null;
  });

  tarihGuncelle(alan: string, tarih: Date | null) {
    this.guncelle(alan, tarih ? tarih.toISOString() : null);
  }

  mailModalAcik = false;
  mailDetay = signal<any>(null);
  private req = inject(FikoYTRequestService);
  mailHesaplari = signal<any[]>([]);
  mailler = signal<any[]>([]);
  private _hesaplarYuklendi = false;

  async mailHesaplariYukle() {
    if (this._hesaplarYuklendi) return;
    try {
      let firmaId = '';
      try { firmaId = JSON.parse(localStorage.getItem('hmi-pano-ayarlar') || '{}').firmaId || ''; } catch {}
      const match: any = { 'aktif': { '$ne': false }, 'silindi': { '$ne': true } };
      if (firmaId) match['firmaId'] = firmaId;
      const sonuc = await this.req.aggregate('FikoYT.sistem.DB.hareketler.aggregate', [
        { '$match': { ...match, 'vt': 'FikoYT.sistem.mail.hesaplar' } },
        { '$sort': { 'email': 1 } }, { '$limit': 50 },
        { '$project': { '_id': 1, 'email': 1 } }
      ]);
      this.mailHesaplari.set(sonuc || []);
      this._hesaplarYuklendi = true;
      this.CD.markForCheck();
    } catch {}
  }

  mailHesapDegisti(hesapId: string | null) {
    this.guncelle('mailHesap', hesapId);
    this.guncelle('mailRef', null);
    this.mailler.set([]);
  }

  ekIndir(ek: any) {
    if (ek.url) { window.open(ek.url, '_blank'); return; }
    const dosyaId = ek.rota || ek._id;
    if (dosyaId) {
      const fapiUrl = (window as any).FikoYT?.fapiUrl || `${location.protocol}//${location.hostname}:9000`;
      window.open(`${fapiUrl}/fapiv1/fikoyt.com.FikoYT.sistem.dosyalar.${dosyaId}.dosya`, '_blank');
    }
  }

  async mailOnizle(mailId: string) {
    if (!mailId) return;
    this.mailDetay.set(null);
    this.mailModalAcik = true;
    this.CD.markForCheck();
    try {
      const sonuc = await this.req.aggregate('FikoYT.sistem.DB.hareketler.aggregate', [
        { '$match': { '_id': mailId, 'vt': 'FikoYT.sistem.mail.mesajlar' } },
        { '$limit': 1 }
      ]);
      const m = sonuc?.[0];
      if (m) {
        const ic = m.icerikler?.[0];
        this.mailDetay.set({
          konu: m.veri?.konu || '(Konusuz)',
          kimden: m.veri?.kimden || '',
          kime: m.veri?.kime || '',
          tarih: m.tarih ? new Date(m.tarih).toLocaleString('tr-TR') : '',
          html: ic?.html || '',
          metin: ic?.aciklama || '',
          ekler: (m.dosyalar || []).map((d: any) => ({ ismi: d.ismi, boyut: d.boyut, rota: d.rota, url: d.url }))
        });
      }
      this.CD.markForCheck();
    } catch { this.mailModalAcik = false; }
  }

  async mailAra(arama: string) {
    const hesapId = this.p().mailHesap;
    if (!hesapId) return;
    try {
      const trMap: Record<string, string> = {i:'[iİ]',İ:'[iİ]',ı:'[ıI]',I:'[ıI]',ş:'[şŞ]',Ş:'[şŞ]',ç:'[çÇ]',Ç:'[çÇ]',ö:'[öÖ]',Ö:'[öÖ]',ü:'[üÜ]',Ü:'[üÜ]',ğ:'[ğĞ]',Ğ:'[ğĞ]'};
      const rx = arama ? Array.from(arama).map(c => trMap[c] || c.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('') : '';
      const match: any = { 'sahip': hesapId, 'silindi': { '$ne': true } };
      if (rx) {
        const rd = { '$regex': rx, '$options': 'i' };
        match['$or'] = [{ 'veri.konu': rd }, { 'veri.kimden': rd }, { 'veri.kime': rd }];
      }
      const sonuc = await this.req.aggregate('FikoYT.sistem.DB.hareketler.aggregate', [
        { '$match': { ...match, 'vt': 'FikoYT.sistem.mail.mesajlar' } },
        { '$sort': { 'tarih': -1 } }, { '$limit': 30 },
        { '$project': { '_id': 1, 'veri.konu': 1, 'veri.kimden': 1, 'veri.kime': 1, 'veri.inReplyTo': 1, 'tarih': 1, 'dosyaSayisi': 1 } }
      ]);
      this.mailler.set((sonuc || []).map((m: any) => ({
        _id: m._id, konu: m.veri?.konu || '', kimden: m.veri?.kimden || '',
        yanitMi: !!m.veri?.inReplyTo, ekSayi: m.dosyaSayisi || 0,
        tarihStr: m.tarih ? new Date(m.tarih).toLocaleDateString('tr-TR', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }) : ''
      })));
      this.CD.markForCheck();
    } catch {}
  }
}
